import React from 'react';
import { motion } from 'framer-motion';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  hoverEffect?: boolean;
}
export function Card({
  children,
  className = '',
  hoverEffect = false
}: CardProps) {
  return <motion.div initial={hoverEffect ? {
    y: 0
  } : undefined} whileHover={hoverEffect ? {
    y: -5
  } : undefined} className={`bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden ${className}`} data-id="element-294">
      {children}
    </motion.div>;
}